export const Routes = {
  APPS: '/apps',
  BUNDLES: '/bundles',
  BUNDLES_LISTINGS: '/bundles/listings',
  CONCEPTS: '/concepts',
  CREATE: '/create',
  DOCS: '/docs',
  EXPLORE: '/explore',
  FAVORITES: '/favorites',
  METADATA: '/metadata',
  MY_APPS: '/my-apps',
  OTHER_PAYMENT: '/other-payment',
  VISUALS: '/visuals',
  PRIVACY_POLICY: '/privacy-policy',
  ROOT: '/',
  SUCCESS: '/success'
};

export const UNAUTH_PATHS = [
  Routes.APPS,
  Routes.BUNDLES,
  Routes.CONCEPTS,
  Routes.OTHER_PAYMENT,
  Routes.PRIVACY_POLICY,
  Routes.SUCCESS,
  Routes.METADATA
];
